module.exports = __webpack_public_path__ + "img/tu4.9340413e.png";